import { render } from "./project-tasks.vue?vue&type=template&id=3fefa4f6"
import script from "./project-tasks.vue?vue&type=script&lang=js"
export * from "./project-tasks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__